import { Theme } from '@mui/material/styles';
import { FileUploadProps } from 'greener-ui-library';

/**
 * Power Profile specific file validation configuration
 */
export const powerProfileValidation: FileUploadProps['validation'] = {
  maxFileSize: 20 * 1024 * 1024, // 20MB
  acceptedTypes: [
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  allowedExtensions: ['.csv', '.xls', '.xlsx'],
};

/**
 * Responsive styles for mode toggle container
 */
export const modeToggleStyles = {
  maxWidth: { xs: '100%', lg: 400 },
} as const;

/**
 * Responsive styles for file upload container
 */
export const fileUploadStyles = {
  maxWidth: { xs: '100%', lg: 824 },
} as const;

/**
 * Typography styles for section titles
 */
export const sectionTitleStyles = {
  mb: '20px',
  fontSize: (theme: Theme) => theme.typography.body1.fontSize,
} as const;
